const { CallApi } = require("app/_helpers/CallApi/CallApi");

export const getAllActivity = async (data) => {
  let url = "/global-configuration/activity";
  return await CallApi(url, "GET", data);
};

export const getActivityById = async (id) => {
  let url = "/global-configuration/activity/" + id;
  return await CallApi(url, "GET");
};

export const createActivity = async (data) => {
  let url = "/global-configuration/activity";
  return await CallApi(url, "POST", data);
};

export const updateActivity = async (id, data) => {
  let url = "/global-configuration/activity/" + data.id;
  return await CallApi(url, "PUT", data);
};

export const deleteActivity = async (id) => {
  let url = "/global-configuration/activity/" + id;
  return await CallApi(url, "DELETE");
};
